
import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { useSelector } from 'react-redux'

function BtypeTable(props) {
   const [dn, setDn] = useState([])

   useEffect(() => {
        
        let ndata = props.vtypeList.filter(g => g.categoryCode === props.categories.categoryCode)  
        
        setDn(ndata)
   },[props.vtypeList, props.categories])

  return (
    <>
   
      <div className="content" >
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Body Type <span style={{float : "right"}}>  <i className="fa fa-refresh" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={f => props.populateTypes()}/></span></CardTitle>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data= {dn}
                  columns={[
                    
                    {
                      Header: "C.Name",
                      accessor: d =>  d.catagoryName,
                    },
                   
                    {
                      Header: "Body",
                      accessor: d => d.vtypeName,
                    },
                   
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  /*
                      You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                    */
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default BtypeTable;